var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "fourth-step-box" }, [
    _c("svg", { staticClass: "icon", attrs: { "aria-hidden": "true" } }, [
      _c("use", { attrs: { "xlink:href": "#icon-Frame1" } })
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        _vm._s(
          _vm.$t("8000130", {
            currency:
              _vm.currencyFilter(_vm.$parent.currency) +
              "/USDT-" +
              _vm.$parent.memo
          })
        )
      )
    ]),
    _vm._v(" "),
    _c("span", { staticClass: "inline-block success-tip" }, [
      _vm._v(_vm._s(_vm.$t("10000022")))
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "precautions-content" }, [
      _c("h3", { staticClass: "bold" }, [_vm._v(_vm._s(_vm.$t("8000194")))]),
      _vm._v(" "),
      _c("p", [_vm._v("· " + _vm._s(_vm.$t("8000195")))]),
      _vm._v(" "),
      _c("p", [_vm._v("· " + _vm._s(_vm.$t("8000196")))]),
      _vm._v(" "),
      _c("p", [_vm._v("· " + _vm._s(_vm.$t("8000197")))])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "form-buttons-box" },
      [
        _c(
          "van-button",
          {
            staticClass: "share-btn",
            attrs: { loading: _vm.posterLoading },
            on: { click: _vm.handleShare }
          },
          [_vm._v(_vm._s(_vm.$t("8000178")))]
        ),
        _vm._v(" "),
        _c(
          "van-button",
          { staticClass: "next-btn", on: { click: _vm.handleGoStatistics } },
          [_vm._v(_vm._s(_vm.$t("10000021")))]
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("canvas", {
      staticStyle: { display: "none" },
      attrs: { id: "myCanvas", width: "340", height: "327" }
    }),
    _vm._v(" "),
    _c("div", {
      directives: [
        { name: "show", rawName: "v-show", value: false, expression: "false" }
      ],
      ref: "QRCode",
      attrs: { id: "QRCode" }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-07895c44", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07895c44","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compontents/freeZone/createSymbol/fourthStep.vue
// module id = w40p
// module chunks = 0